'use client';

import { ReactNode } from 'react';

import Image from 'next/image';

import leftArrowIcon from '@/assets/icons/home-page-slider-chevron-right.svg';

interface ImageCarouselDotsProps {
  dots: ReactNode;
  goNext: () => void;
  goBack: () => void;
}

const ImageCarouselDots = ({ dots, goBack, goNext }: ImageCarouselDotsProps) => {
  return (
    <div className="absolute left-0 z-30 flex h-[52px] w-full items-center justify-center gap-3 sm:-bottom-5 lg:-bottom-[45px]">
      <button className="flex h-9 w-9 items-center justify-center border-0 bg-transparent" onClick={goNext}>
        <Image className="!rotate-180" src={leftArrowIcon} alt="" />
      </button>
      <ul className="mt-1 flex h-9 items-center justify-center gap-3">{dots}</ul>
      <button className="flex h-9 w-9 items-center justify-center border-0 bg-transparent" onClick={goBack}>
        <Image src={leftArrowIcon} alt="" />
      </button>
    </div>
  );
};

export default ImageCarouselDots;
